/**
 *
 * validate if the input name has the correct name format
 * return true if the input name has correct format, false otherwise
 *
 * @param {string} name input string to be validated
 */
export const validateName = (name: string | null) => {
  if (name) {
    var regexp = new RegExp(/^[a-zA-Z\s,()/.@'-]+$/);
    return regexp.test(name);
  } else {
    return false;
  }
};
